import { tokenLogin as requestTokenLogin } from '@/modules/auth/shared/api';
import {
  setAccessToken,
  setAxiosHeaders,
  setRefreshToken,
  setUserData,
} from '@/modules/auth/shared/hooks/useTokenManager';

/**
 * Exchanges a one-time token for an auth session: stores access/refresh tokens,
 * sets axios headers, and seeds user data.
 *
 * Was a redux-thunk (`(t) => (dispatch) => …` dispatching userLoggedIn); after
 * the Redux store retirement it is a plain async function. User state is now
 * seeded by setUserData → appStore, and the full profile is loaded immediately
 * afterwards by Router.handleUserProfile.
 */
export const tokenLogin = (t: string) =>
  requestTokenLogin(t).then((data: { access_token: string; refresh_token: string }) => {
    setAccessToken(data.access_token);
    setRefreshToken(data.refresh_token);
    setAxiosHeaders();
    setUserData({ accessToken: data.access_token });
  });
